import { RouteConfig } from 'vue-router';

import { Rules as CaslRules } from '../../../back/src/casl/casl.constants';

import BalancasIndex from '@/pages/balancas/BalancasIndex.vue';

const routes: RouteConfig[] = [
  {
    path: '/balancas',
    name: 'BalancasIndex',
    component: BalancasIndex,
    meta: {
      icon: 'mdi-scale',
      rules: [CaslRules.Balancas.listar],
    },
  },
];

export default routes;
